module.exports = __webpack_public_path__ + "static/icon-service.fa7e6e6f.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/festival/icon-service.png
// module id = 276
// module chunks = 2